import { get } from "lodash";

const EMPTY = { results: [], next: null };

const getFreezeEvents = state => {
  const id = get(state, "factoringClient.id", "");
  return get(state, `factoringClient.freezeEvents.${id}`, EMPTY);
};

export default getFreezeEvents;
